import { Card, Tabs } from 'antd';
import { AcquiredPropertiesTable } from '../AcquiredPropertiesTable';
import { SoldPropertiesTable } from '../SoldPropertiesTable';
import { PortfolioAggregationsTable } from '../PortfolioAggregationsTable';
import { useGetAccountTransactions } from '../../../../../../queries/Account';
import { showErrorToast } from '../../../../../../services/notificationsService';

export const Transactions = ({
  isMultiFamilySelected,
  isVacantSelected,
  selectedRange,
  postgresId,
  appliedFilters,
}) => {
  const {
    data: accountTransactionsData,
    isLoading: isTransactionsLoading,
    isError: isTransactionsError,
  } = useGetAccountTransactions({ selectedRange, postgresId, appliedFilters });

  if (isTransactionsError) {
    showErrorToast('Fetching transactions failed!');
  }

  const items = [
    {
      key: '1',
      label: `Acquisitions (${
        accountTransactionsData?.acquiredProperties?.length || 0
      })`,
      children: (
        <Card>
          <AcquiredPropertiesTable
            isLoading={isTransactionsLoading}
            data={accountTransactionsData}
            isMultiFamilySelected={isMultiFamilySelected}
            isVacantSelected={isVacantSelected}
          />
        </Card>
      ),
    },
    {
      key: '2',
      label: `Dispositions (${
        accountTransactionsData?.soldProperties?.length || 0
      })`,
      children: (
        <Card>
          <SoldPropertiesTable
            isLoading={isTransactionsLoading}
            data={accountTransactionsData}
            isMultiFamilySelected={isMultiFamilySelected}
            isVacantSelected={isVacantSelected}
          />
        </Card>
      ),
    },
    {
      key: '3',
      label: `Inter-company transfers (${
        accountTransactionsData?.portfolioAggregations?.length || 0
      })`,
      children: (
        <Card>
          <PortfolioAggregationsTable
            isLoading={isTransactionsLoading}
            data={accountTransactionsData}
          />
        </Card>
      ),
    },
  ];

  return <Tabs items={items} className="account-tabs transactions" />;
};
